import { Link } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";
import type { ReactNode } from "react";

export function LegalPage({
  title,
  updatedAt,
  intro,
  children,
}: {
  title: string;
  updatedAt: string;
  intro?: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-[#F6F1E8]">
      <header className="border-b border-black/5 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2">
            <div className="grid h-8 w-8 place-items-center rounded-lg bg-[#0C1B33] text-[10px] font-black tracking-widest text-white">
              101
            </div>
            <span className="font-[Manrope] text-sm font-extrabold tracking-tight text-[#0C1B33]">
              Projeto 101
            </span>
          </Link>
          <div className="inline-flex items-center gap-1 text-xs text-[#5C6675]">
            <ShieldCheck className="h-3.5 w-3.5" /> Documento oficial
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 sm:py-14">
        <div className="rounded-2xl border border-black/5 bg-white p-6 shadow-sm sm:p-10">
          <div className="text-[11px] font-semibold uppercase tracking-widest text-[#1E7A5C]">
            Projeto 101 · 101 Negócios Reais
          </div>
          <h1 className="mt-2 font-[Manrope] text-3xl font-extrabold tracking-tight text-[#0C1B33] sm:text-4xl">
            {title}
          </h1>
          <p className="mt-2 text-xs text-[#5C6675]">Última atualização: {updatedAt}</p>
          {intro && (
            <p className="mt-6 text-[15px] leading-relaxed text-[#0C1B33]">{intro}</p>
          )}
          <div className="legal-prose mt-8 space-y-6 text-[15px] leading-relaxed text-[#0C1B33]">
            {children}
          </div>
        </div>

        <nav className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-[#5C6675]">
          <Link to="/termos" className="hover:text-[#1E7A5C]">Termos de Uso</Link>
          <Link to="/privacidade" className="hover:text-[#1E7A5C]">Política de Privacidade</Link>
          <Link to="/reembolso" className="hover:text-[#1E7A5C]">Política de Reembolso</Link>
          <Link to="/aviso-legal" className="hover:text-[#1E7A5C]">Aviso Legal</Link>
          <Link to="/" className="hover:text-[#1E7A5C]">Voltar ao site</Link>
        </nav>
        <p className="mt-4 text-center text-xs text-[#5C6675]">
          Contato: <a href="mailto:suporte@101negocios.com.br" className="underline">suporte@101negocios.com.br</a>
        </p>
      </main>
    </div>
  );
}

export function LegalSection({ n, title, children }: { n: number | string; title: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="font-[Manrope] text-lg font-extrabold tracking-tight text-[#0C1B33] sm:text-xl">
        {n}. {title}
      </h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-[#0C1B33]/90">
        {children}
      </div>
    </section>
  );
}

export function LegalList({ items }: { items: ReactNode[] }) {
  return (
    <ul className="ml-5 list-disc space-y-1.5 marker:text-[#1E7A5C]">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}
